<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Device Diagnostic Payloads</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Profile</th>
                        <th>Type</th>
                        <th>Payload</th>
                        <th>Timestamp</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="payload in payloads" v-if="payloads.length" :key="payload.id" class="text-left">
                        <td>{{ payload.profile }}</td>
                        <td>{{ payload.type }}</td>
                        <td class="cursor-pointer" @click="showPayload(payload)">
                            {{ JSON.stringify(payload.payload).substr(0, 10) + '...' }}
                        </td>
                        <td>{{ formatDateTime(payload.created_at) }}</td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @click="fetchPayloads"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>


    <v-dialog v-model="dialogSwitch" max-width="700" scrollable>
        <v-card>
            <v-card-title>{{ selectedPayload.type }}: Payload</v-card-title>

            <v-card-text>
                <pre>{{ selectedPayload.payload }}</pre>
            </v-card-text>

            <v-card-actions></v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {formatDateTime} from '@/composables/useTimezone';
import ThBtn from "@/components/globals/th-btn.vue";
import {strOperations} from "@/composables/globals";

const payloads = ref([]);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const sortedType = ref(null);
const sortedColumn = ref(null);
const dialogSwitch = ref(false);
const selectedPayload = ref(null);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchPayloads();
});
const sort = (sorting) => {
    sortedColumn.value = sorting.column;
    sortedType.value = sorting.order;
    fetchPayloads();
}
const showPayload = (payload) => {
    selectedPayload.value = payload;
    dialogSwitch.value = true
}
const fetchPayloads = () => {
    const data = {
        page: currentPage.value,
        order: sortedType.value,
        sort: sortedColumn.value,
    }
    send('get', `admin/diagnostics/payloads`, data)
        .then((response) => {
            payloads.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Sim payloads could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
</script>


<style scoped>
pre {
    color: #ccc;
    padding: 5px;
    background: #2d2d2d;
    white-space: pre-wrap;
}
</style>
